import { ICompileService } from "angular";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import { FilterProvider } from "../../../records/grids/columns/filters/FilterProvider";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import { OptionsFilter } from "../../../records/grids/columns/filters/subFilters/OptionsFilter";
import { RecordDataSource } from "../../../records/grids";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";

export const vsObjectName = "processInstances";

processInstancesObjectConfig.$inject = [RecordGridViewServiceProviderName];
export function processInstancesObjectConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  configureGrid(recordGridViewServiceProvider);
}

const statusCategoryLookup: any = {
  InProgress: "In Progress",
  Complete: "Complete",
  Cancelled: "Cancelled",
};

function configureGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ColumnDefinitionServiceName,
    ServerUtilityName,
    GridSettingsServiceName,
    "$compile",
    (
      columnDefinitionService: ColumnDefinitionService,
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService,
      $compile: ICompileService
    ): GridConfiguration => {
      return {
        defaultSort: "-CreatedDate",
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/processes/instances"
        ),
        gridSettings: gridSettingsService.getGridSettings(Symbol(vsObjectName)),
        namePlural: "All Processes",
        nameSingular: "Process",
        columns: [
          columnDefinitionService.getNumberColDef({
            field: "Id",
            header: "Id",
            hide: true,
          }),
          columnDefinitionService.getStringColDef({
            field: "GroupId",
            header: "Group",
            hide: true,
          }),
          columnDefinitionService.getStringColDef({
            field: "DisplayName",
            header: "Process Type",
          }),
          columnDefinitionService.getStringColDef({
            field: "ProcessInstancesStatus",
            header: "Process Status",
          }),
          columnDefinitionService.getStringColDef({
            field: "StatusCategory",
            header: "Process Status Category",
            valueGetter: (params) =>
              statusCategoryLookup[(<any>params.data).StatusCategory],
            filter: new FilterProvider("StatusCategory", $compile)
              .addFilter(
                "=",
                new OptionsFilter({
                  displayName: "Status Category",
                  options: Object.entries(statusCategoryLookup).map((entry) => {
                    return {
                      value: entry[0],
                      display: <string>entry[1],
                    };
                  }),
                  queryFieldNames: ["StatusCategory"],
                })
              )
              .getGridFilterFactory(),
          }),
          columnDefinitionService.getDateTimeColDef({
            field: "CompletedTime",
            hide: true,
          }),
          columnDefinitionService.getDateTimeColDef({
            field: "StatusStartTime",
            header: "Entered State On",
            hide: true,
          }),
          columnDefinitionService.getStringColDef({
            field: "LastActivityByDisplayName",
            header: "Last Activity By",
            hide: true,
          }),
          columnDefinitionService.getDateTimeColDef({
            field: "LastActivityTime",
            header: "Last Activity On",
            hide: true,
          }),
          columnDefinitionService.getStringColDef({
            field: "CreatedByDisplayName",
            header: "Created By",
            hide: true,
          }),
          columnDefinitionService.getDateTimeColDef({
            field: "CreatedDate",
            header: "Created On",
            hide: true,
          }),
        ],
      };
    },
  ]);
}
